import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatterFileType } from '@models/matter';

@Component({
	selector: 'matter-type-selector',
	templateUrl: 'matter-type-selector.component.html',
	standalone: false,
})
export class MatterTypeSelectorComponent {
	@Input() set matterTypes(matterType: MatterFileType[]) {
		this.initDocumentAvailableInCheckbox(matterType);
	}
	@Input() showMatterTypes: MatterFileType[];
	@Input() disabled: boolean = true;

	@Output() matterTypesChange = new EventEmitter<MatterFileType[]>();

	public documentAvailableInSale = false;
	public documentAvailableInPurchase = false;
	public documentAvailableInRefinance = false;

	get MatterFileType(): typeof MatterFileType {
		return MatterFileType;
	}

	constructor() {
		this.showMatterTypes = Object.values(MatterFileType);
	}

	initDocumentAvailableInCheckbox(matterTypes: MatterFileType[]) {
		this.documentAvailableInPurchase = matterTypes.includes(
			MatterFileType.PURCHASE,
		);
		this.documentAvailableInSale = matterTypes.includes(MatterFileType.SALE);
		this.documentAvailableInRefinance = matterTypes.includes(
			MatterFileType.REFINANCE,
		);
	}

	onDocumentAvailableInRefinanceChange(value: boolean) {
		this.documentAvailableInRefinance = value;
		this.matterTypesChange.emit(this.getDocumentAvailableInArray());
	}

	onDocumentAvailableInPurchaseChange(value: boolean) {
		this.documentAvailableInPurchase = value;
		this.matterTypesChange.emit(this.getDocumentAvailableInArray());
	}

	onDocumentAvailableInSaleChange(value: boolean) {
		this.documentAvailableInSale = value;
		this.matterTypesChange.emit(this.getDocumentAvailableInArray());
	}

	getDocumentAvailableInArray(): MatterFileType[] {
		const newMatterType: MatterFileType[] = [];

		if (this.documentAvailableInPurchase) {
			newMatterType.push(MatterFileType.PURCHASE);
		}

		if (this.documentAvailableInSale) {
			newMatterType.push(MatterFileType.SALE);
		}

		if (this.documentAvailableInRefinance) {
			newMatterType.push(MatterFileType.REFINANCE);
		}

		return newMatterType;
	}
}
